<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Campaign Goal
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
            <span>What you would like to achieve with your advertising campaign?</span>
          </v-tooltip>
        </h1>

        <campaign-element
          v-for="(type, index) in campaignTypes"
          :key="index"
          :campaign="type"
          :selectedCampaign="campaign.type"
          @selectCampaign="selectCampaign"
        />
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row>
        <v-spacer />
        <v-btn
          color="primary"
          @click="nextPage"
        >Next</v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import CampaignElement from './CampaignElement.vue'
import campaignTypes from '../../../../static/adlabel-campaign-types'
export default {
  name: 'campaign-type',
  components:
    {
      CampaignElement
    },
  data () {
    return {
      campaignTypes: [],
      next: true
    }
  },
  props: {
    campaign: {
      type: Object,
      default: () => {}
    }
  },
  created () {
    this.campaignTypes = campaignTypes
  },
  methods: {
    selectCampaign (campaign) {
      if (campaign) this.$emit('setCampaignProperty', 'type', campaign)
    },
    nextPage () {
      this.$emit('next')
    }
  }
}
</script>
